module.exports = __webpack_public_path__ + "static/media/cp4.9cb3388a.png";